import { useState, useEffect } from 'react';
import store from 'redux/store'
import { getLocal } from '@walletconnect/utils'
import IframeLoader from 'components/ui/IframeLoader/IframeLoader'
import { RangoExchange } from 'shared/pages/Exchange/RangoExchange';
import Sider from 'shared/components/Sider';

const Rango = () => {
    return (
        <Sider>
            <RangoExchange />
        </Sider>
    )
}

export default Rango;
